import React from "react";
import PropTypes from "prop-types";

import {NavLink} from 'react-router-dom';
import logo from "assets/img/sandos/logo.png";

import './root.scss';

const JoinLoyalty = ({ brandDetails }, context) => {
  return (
    <div className="w-full lg:w-3/5 border-b pb-8">
      <h2 className="text-white text-title mt-4 mb-2">
        <img src={logo} className="w-64" alt="logo" />
        {context.t('Join now')}
      </h2>

      <p className="pb-3 text-base">
        {context.t("You are just a few clicks away from being part of our loyalty program.")}
      </p>
      <p className="text-base">
        {context.t("Complete the registration form and start enjoying exclusive benefits.")}
      </p>

      <NavLink to="/register/#register-form" exact className="join-button block mr-auto mt-4 w-full lg:w-1/3">
        {context.t('Join the club')}
      </NavLink>
    </div>
  );
};

JoinLoyalty.propTypes = {
  brandDetails: PropTypes.object.isRequired,
};

JoinLoyalty.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default JoinLoyalty;
